import { BaseApi } from '../base/BaseApi';
import { ApiRoutes } from '../routes';
import { AdminUsersQueryDTO, AdminUsersResponseDTO } from 'infrastructure/dtos/admin';
import { IAdminApi } from './IAdminApi';

export class AdminApi extends BaseApi implements IAdminApi {
  async getUsers(query: AdminUsersQueryDTO): Promise<AdminUsersResponseDTO> {
    return await this.callApi(ApiRoutes.Admin.GetUsers, query);
  }
}
